module.exports = __webpack_public_path__ + "static/media/locker.1b57738a.png";